export enum TaskStateFilterType {
	All = 0,
	Open = 1,
	Expired = 2,
	Closed = 3,
	Cancelled = 4
}